import { render, staticRenderFns } from "./couponRuleList.vue?vue&type=template&id=a1b568fc&scoped=true"
import script from "./couponRuleList.vue?vue&type=script&lang=js"
export * from "./couponRuleList.vue?vue&type=script&lang=js"
import style0 from "./couponRuleList.vue?vue&type=style&index=0&id=a1b568fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b568fc",
  null
  
)

export default component.exports